import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    customColors: {
      blue: {
        50: string;
        100: string;
        200: string;
        300: string;
        400: string;
        450: string;
        500: string;
        600: string;
        700: string;
        800: string;
        900: string;
        950: string;
      };
      gray: {
        50: string;
        100: string;
        200: string;
        300: string;
        400: string;
        500: string;
        600: string;
        700: string;
        800: string;
        900: string;
        950: string;
        960: string;
      };
      purple: {
        light: string;
        main: string;
      };
      pink: {
        100: string;
        200: string;
      };
      error: {
        hover: string;
      };
    };
  }
  interface PaletteOptions {
    customColors?: Palette['customColors'];
  }
}

const theme = createTheme({
  typography: {
    fontFamily: 'Inter',
    h1: {
      fontSize: '40px',
      lineHeight: '36px',
      fontWeight: '600',
      color: '#26262B',
    },
    h2: {
      fontSize: '38px',
      lineHeight: '32px',
      fontWeight: '400',
      color: '#26262B',
    },
    h3: {
      fontSize: '24px',
      lineHeight: '32px',
      fontWeight: '400',
      color: '#26262B',
    },
    h4: {
      fontSize: '28px',
      lineHeight: '20px',
      fontWeight: '400',
      color: '#26262B',
    },
  },
  palette: {
    primary: {
      main: '#447AED',
      light: '#C2D8FB',
      dark: '#2648CF',
    },
    secondary: {
      main: '#9e9e9e',
      light: '#cfcfcf',
      dark: '#707070',
    },
    error: {
      main: '#c61616',
    },
    warning: {
      main: '#ff7324',
    },
    success: {
      main: '#64a338',
    },
    info: {
      main: '#447aed',
    },
    common: {
      white: '#ffffff',
    },
    customColors: {
      blue: {
        50: '#ebeef4',
        100: '#dde8fc',
        200: '#c2d8fb',
        300: '#98bff8',
        400: '#98bff8',
        450: '#6794f5',
        500: '#447aed',
        600: '#2e5be2',
        700: '#2648cf',
        800: '#253ca8',
        900: '#233685',
        950: '#161e45',
      },
      gray: {
        50: '#f7f7f8',
        100: '#eeeef0',
        200: '#d9d9de',
        300: '#b7b7c2',
        400: '#9091a0',
        500: '#737484',
        600: '#5c5c6d',
        700: '#4c4c58',
        800: '#41424b',
        900: '#393941',
        950: '#26262b',
        960: '#F9F9F9',
      },
      purple: {
        light: '#efe6fa',
        main: '#6915d5',
      },
      pink: {
        100: '#FDECEC',
        200: '#F9EBEB',
      },
      error: {
        hover: '#AC0606',
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '24px',
          borderRadius: '6px',
          textTransform: 'none',
          color: '#fff',
        },
        sizeMedium: {
          padding: '10px 24px',
        },
        sizeSmall: {
          padding: '6px 16px',
          fontSize: '14px',
          lineHeight: '20px',
        },
        sizeLarge: {
          padding: '12px 28px',
          fontSize: '18px',
          lineHeight: '28px',
        },
        containedPrimary: {
          backgroundColor: '#447AED',
          '&:hover': {
            backgroundColor: '#2648CF',
          },
        },
        outlined: {
          borderColor: '#447AED',
          color: '#447AED',
          '&:hover': {
            borderColor: '#2648CF',
            color: '#2648CF',
            backgroundColor: '#DDE8FC',
          },
        },
      },
    },
  },
});

export default theme;
